export default __webpack_public_path__ + "static/media/Mark-2-HUD-Artificial Horizon.6d8fdc35.jpg";